// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"721d2040","117":"dcf72839","221":"e50f6b8b","372":"5bf58681","393":"5d13db60","404":"b98aa2c7","454":"8b65f2f1","483":"f21bb713","530":"006a15e0","721":"10f39903","758":"73ef7063","853":"c9bae4f4"}[chunkId] + ".chunk.js";
};